module.exports = __webpack_public_path__ + "img/1.48681666.jpg";